// Clausole vessatorie (artt. 1341-1342 c.c.) dei Termini e Condizioni di Servizio.
// FONTE UNICA per checkbox di registrazione, ProfileLegalConsent e step OTP di
// approvazione specifica (VerifyEmailPage).
//
// Elenco allineato all'elenco in calce alle T&C (rev. 17/10/2026, commenti
// finali dell'avvocato del 24/08/2026 che aggiungono gli artt. 3, 4, 5 e 10;
// aggiornato il 17/10/2026 con gli artt. 6, 13.3 e 22 e con 23.2 e 23.4 separati).
// Se cambia l'elenco in calce alle T&C va cambiato anche qui (e TERMS_VERSION).
//
// Dopo Cass. ord. n. 20945/2026 la sola checkbox NON è sufficiente per
// l'approvazione specifica: serve la firma elettronica semplice (codice OTP)
// nello step di verifica: vedi VerifyEmailPage.

export interface VexatiousClause {
  ref: string;
  title: string;
}

export const VEXATIOUS_CLAUSES: VexatiousClause[] = [
  { ref: '3', title: 'Descrizione del servizio (modifiche alle funzionalità e recesso)' },
  { ref: '4', title: 'Requisiti di sistema e accesso' },
  { ref: '5', title: 'Livelli di servizio (SLA)' },
  { ref: '6', title: 'Account, registrazione e sicurezza (sospensione o risoluzione per condivisione delle credenziali)' },
  { ref: '7', title: 'Piani di abbonamento, prezzi e fatturazione' },
  { ref: '9', title: 'Politica di rimborsi e diritto di recesso' },
  { ref: '10', title: 'Contenuti del Cliente, proprietà e backup' },
  { ref: '11', title: 'Politica di uso accettabile' },
  { ref: '13.3', title: 'Deprecazione API (modifiche e cessazione delle API)' },
  { ref: '15', title: 'Garanzie, esclusioni e limitazioni' },
  { ref: '16', title: 'Limitazione di responsabilità' },
  { ref: '17', title: 'Indennizzo da parte del Cliente' },
  { ref: '18', title: 'Eventi di forza maggiore' },
  { ref: '19', title: 'Sospensione, recesso, risoluzione ed effetti della cessazione del contratto' },
  { ref: '20', title: 'Modifiche ai termini di servizio' },
  { ref: '21', title: 'Cessione del contratto e subappalto' },
  { ref: '22', title: 'Comunicazioni ufficiali (presunzione di ricezione)' },
  { ref: '23.2', title: 'Giurisdizione e foro competente' },
  { ref: '23.4', title: 'Rinuncia a class action' },
];

/** "3, 4, 5, …, 23.2 e 23.4" */
export const VEXATIOUS_REFS = VEXATIOUS_CLAUSES.map((c) => c.ref)
  .join(', ')
  .replace(/, ([^,]+)$/, ' e $1');

export const VEXATIOUS_LABEL =
  `Approvo specificamente, ai sensi degli artt. 1341-1342 c.c., le clausole ${VEXATIOUS_REFS} dei Termini`;

export const VEXATIOUS_DETAIL = VEXATIOUS_CLAUSES.map((c) => `${c.ref} ${c.title}`).join(' · ');

// Versione inglese (stessi riferimenti, titoli tradotti) - usata dalla entry EN di /register.
const VEXATIOUS_TITLES_EN: Record<string, string> = {
  '3': 'Description of the service (changes to features and withdrawal)',
  '4': 'System requirements and access',
  '5': 'Service levels (SLA)',
  '6': 'Account, registration and security (suspension or termination for sharing credentials)',
  '7': 'Subscription plans, prices and billing',
  '9': 'Refund policy and right of withdrawal',
  '10': 'Customer content, ownership and backup',
  '11': 'Acceptable use policy',
  '13.3': 'API deprecation (changes to and discontinuation of the APIs)',
  '15': 'Warranties, exclusions and limitations',
  '16': 'Limitation of liability',
  '17': 'Indemnification by the customer',
  '18': 'Force majeure',
  '19': 'Suspension, withdrawal, termination and effects of termination',
  '20': 'Changes to the terms of service',
  '21': 'Assignment and subcontracting',
  '22': 'Official communications (presumed receipt)',
  '23.2': 'Jurisdiction and competent court',
  '23.4': 'Class action waiver',
};

export const VEXATIOUS_REFS_EN = VEXATIOUS_CLAUSES.map((c) => c.ref)
  .join(', ')
  .replace(/, ([^,]+)$/, ' and $1');

export const VEXATIOUS_LABEL_EN =
  `Pursuant to Articles 1341-1342 of the Italian Civil Code, I specifically approve clauses ${VEXATIOUS_REFS_EN} of the Terms`;

export const VEXATIOUS_DETAIL_EN = VEXATIOUS_CLAUSES
  .map((c) => `${c.ref} ${VEXATIOUS_TITLES_EN[c.ref] ?? c.title}`)
  .join(' · ');
